import { render, staticRenderFns } from "./d-title.vue?vue&type=template&id=b99a6bc8&scoped=true&"
import script from "./d-title.vue?vue&type=script&lang=js&"
export * from "./d-title.vue?vue&type=script&lang=js&"
import style0 from "./d-title.vue?vue&type=style&index=0&id=b99a6bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99a6bc8",
  null
  
)

export default component.exports